import { Injectable } from '@angular/core';
import { GetPartnerBySubfolderCommand, GetPartnerBySubfolderCommandOutput, PartnerBySubfolderOutput } from 'frontend.client.api';
import { BehaviorSubject } from 'rxjs';
import { Partner } from '../models/partner';
import { ApiService } from './api.service';
import { RouterService } from './router.service';

export interface PartnerState {
  partnerData?: GetPartnerBySubfolderCommandOutput;
  subFolder?: string;
}

@Injectable({
  providedIn: 'root',
})
export class PartnerStateService {
  private partnerState$ = new BehaviorSubject<PartnerState>({});

  constructor(
    private router: RouterService,
    private apiService: ApiService,
  ) {
    this.router.getState().subscribe((routerState) => {
      if (this.partnerState$.getValue()?.subFolder !== routerState.subFolder) {
        this.loadPartner(routerState.subFolder);
      }
      if (!this.partnerState$.getValue()?.subFolder) {
        this.setPartner({
          subFolder: routerState.subFolder,
        });
      }
    });
  }

  public get partnerState() {
    return this.partnerState$;
  }

  public get partner() {
    return this.partnerState$.getValue().partnerData
  }

  private async loadPartner(routerSubFolder?: string) {
    const command = new GetPartnerBySubfolderCommand({
      partnerSubfolder: routerSubFolder ?? '',
    });
    try {
      const response = await this.apiService.client?.send(command);
      if (response) this.setPartner({ subFolder: routerSubFolder, partnerData: response });
    } catch {
      this.setPartner({
        subFolder: undefined,
        partnerData: undefined,
      });
      this.router.unknownPartner();
    }
  }

  public setPartner(partner: PartnerState) {
    this.partnerState$.next({ ...partner });
  }
}
